export type Iteratee<T> = (data: T) => string;

export function compareEntity<T>(
  entity: T,
  iterations: Iteratee<T>[],
  searchTerm: string
) {
  return iterations.some((iteratee) =>
    iteratee(entity).toLocaleLowerCase().includes(searchTerm)
  );
}

export default function searchBy<T extends object>(
  array: T[],
  iterations: Iteratee<T>[],
  searchTerm: string
) {
  const lowerCaseSearchTerm = searchTerm.toLocaleLowerCase();

  return array.filter((entity) =>
    compareEntity(entity, iterations, lowerCaseSearchTerm)
  );
}
